import type { HTMLAttributes, LiHTMLAttributes } from "react";
import { cx } from "./cx";

/**
 * Generic list-row shell — a vertical stack of rounded, raised card-rows. This
 * is the reusable half of the signed-in app's "list" surfaces: it owns ONLY the
 * shared visual silhouette (surface, border, radius, hover elevation) and the
 * stack spacing. The column layout of a row's cells is the consumer's job (a
 * modifier class on ListRow setting `grid-template-columns`), because that
 * differs per surface. Extracted from the My Maps list view (which is otherwise
 * too map-coupled — thumbnail, kebab menu, live chip — to share as a component)
 * so the billing invoices list reads as the same design instead of a bespoke
 * table.
 */
export function ListRows({ className, ...rest }: HTMLAttributes<HTMLUListElement>) {
  return <ul className={cx("pz-listrows", className)} {...rest} />;
}

export function ListRow({ className, ...rest }: LiHTMLAttributes<HTMLLIElement>) {
  return <li className={cx("pz-listrow", className)} {...rest} />;
}
